import { ReactElement, useState } from "react";
import InputField from "../components/InputField";
import Title from "../components/Title";
import UnlockButton from "../components/UnlockButton";
import { useNavigate } from "react-router-dom";
import { CheckCode } from "../data/ScavengerHunts";

const ScavengerHuntPage = ({
  solutionCode,
  text,
}: {
  solutionCode: string;
  text: ReactElement;
}) => {
  const [code, setCode] = useState("");
  const navigate = useNavigate();

  const checkCode = () => {
    if (CheckCode(code, solutionCode)) {
      navigate("/congrats/" + code);
    } else {
      alert("Falscher Code!");
    }
  };

  return (
    <div className="scavengerhunt-text">
      {text}
      <hr />
      <Title title="Gib den Code ein" />
      <InputField value={code} setValue={setCode} />
      <UnlockButton onClickHandler={checkCode} />
    </div>
  );
};

export default ScavengerHuntPage;
